import LogContext from '../context/LogContext';
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import axios from 'axios';
axios.defaults.withCredentials = true
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

export default function SignUp() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isEmail, setIsEmail] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const myContext = useContext(LogContext);

    const loginHandler = async (e) => {
        e.preventDefault();
        setIsSubmitting(true)
        console.log(backendUrl)
        try {
            const response = await axios.post(`${backendUrl}/login`, { email, password }, {
                withCredentials: true
            })
            if (response.status != 200) {
                setIsSubmitting(false)
                alert('Invalid Credentials')
            }
            else {
                console.log(response)
                const user = response.data;
                const authUser = await axios.get(`${backendUrl}/auth`, {
                    withCredentials: true
                });
                if (authUser.status != 200) {
                    setIsSubmitting(false)
                    alert("Unauthorized");
                }
                else {
                    setIsSubmitting(false)
                    alert("Authorized");
                    myContext.updateUser(user);
                    const tokenMsg = await authUser.data
                    navigate('/', { replace: true });
                    // Delay the reload slightly to ensure the navigation completes
                    setTimeout(() => {
                        window.location.reload();
                    }, 0);
                }
            }

        }
        catch (error) {
            setIsSubmitting(false);
            alert("Username password missmatch");
            console.log("Invalid Credentials or not secure login", error);
        }
    }
    useEffect(() => {
        if (emailRegex.test(email)) {
            setIsEmail(true)
        }
        else {
            setIsEmail(false)
        }
    }, [email]);
    useEffect(() => {
        document.getElementById('email').value = '';
        document.getElementById('password').value = '';
    }, [])
    useEffect(() => {
        window.scrollTo({ top: 2, behavior: 'smooth' })
    }, [])
    return (
        <>
            <div className='createAccount'>
                <div className='signIn row' >
                    <form onSubmit={loginHandler} className='form col-md-3 col-sm-2' style={{ margin: '15px 15px' }}>
                        <h3 style={{ marginBottom: '3rem' }}>Sign In</h3>
                        <label className='pull-left' htmlFor="email" style={{ minHeight: '20px' }}>
                            {!isEmail && email != '' && <div style={{ fontSize: '12px', fontWeight: '300' }}><span style={{ color: "" }}>Please enter a valid email address </span><i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i></div>}
                            {isEmail && <div style={{ fontSize: '12px' }}><span style={{ color: "green" }}></span><i className="fa-solid fa-circle-check" style={{ color: "green" }}></i></div>}
                        </label>
                        <input
                            type="text"
                            name="username"
                            id="email" placeholder='Email'
                            onChange={(e) => { setEmail(e.target.value) }} /><br />

                        <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder='Password'
                            onChange={(e) => { setPassword(e.target.value) }} /><br />
                        <button type="submit" className="btn button-submit" disabled={!isEmail}>{isSubmitting ? <BeatLoader color="#84d2e6" /> : "Submit"}</button>
                    </form>
                </div>
                <div className='signIn row text-center' style={{ marginTop: '2rem', marginBottom: '3rem' }}>
                    <div className='form col-md-3 ahaa' style={{ margin: '0px 19px' }}>
                        <button className="btn-new-account" onClick={() => window.location.href = '/register'}>Create a Kidorise account</button>
                    </div>
                </div>
            </div>
        </>
    )
}
